import { FC } from 'react';

import { Head, Link } from '@inertiajs/react';
import { ArrowLeft } from 'lucide-react';

import { RelatedPosts } from './RelatedPostSidebar';
import { BlogPost } from '../../types';
import { formatDate } from '../../utils';

type BlogShowProps = {
    blogPost: BlogPost;
    relatedPosts: BlogPost[];
};

const BlogShow: FC<BlogShowProps> = ({ blogPost, relatedPosts }) => (
    <>
        <Head title={blogPost.title} />

        <div className="container mx-auto max-w-6xl py-10">
            <div className="mb-8">
                <Link
                    href="/blog"
                    className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground"
                >
                    <ArrowLeft className="h-4 w-4" />
                    До блогу
                </Link>
            </div>

            <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_18rem]">
                <article className="min-w-0">
                    {blogPost.cover_image_url && (
                        <img
                            src={blogPost.cover_image_url}
                            alt={blogPost.title}
                            className="mb-8 aspect-[16/7] w-full rounded-2xl object-cover"
                        />
                    )}

                    <header className="mb-8">
                        <div className="mb-4 flex items-center gap-3 text-sm text-muted-foreground">
                            <time dateTime={blogPost.published_at}>
                                Опубліковано {formatDate(blogPost.published_at)}
                            </time>
                            <span>Автор: CartOn</span>
                            <div className="flex flex-wrap gap-1">
                                {(blogPost.tags || []).map((tag) => (
                                    <span
                                        key={tag}
                                        className="rounded-full bg-slate-200 px-3 py-1 text-xs font-medium text-slate-700"
                                    >
                                        #{tag}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <h1 className="mb-4 text-3xl font-semibold md:text-4xl">
                            {blogPost.title}
                        </h1>
                    </header>

                    <div
                        className="prose max-w-none prose-gray"
                        dangerouslySetInnerHTML={{
                            __html: blogPost.content || '',
                        }}
                    />
                </article>

                <RelatedPosts posts={relatedPosts} />
            </div>
        </div>
    </>
);

export default BlogShow;
